// extracted by mini-css-extract-plugin
export default {"Loading":"📚19-10-2HvRmM","Spinner":"📚19-10-2_xbIq","spin-one-turn":"📚19-10-2_J3x8"};